"use strict";

function r(r) {
  return function (r) {
    if (Array.isArray(r)) return t(r);
  }(r) || function (r) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(r)) return Array.from(r);
  }(r) || function (r, e) {
    if (!r) return;
    if ("string" == typeof r) return t(r, e);
    var n = Object.prototype.toString.call(r).slice(8, -1);
    "Object" === n && r.constructor && (n = r.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(n);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return t(r, e);
  }(r) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function t(r, t) {
  (null == t || t > r.length) && (t = r.length);

  for (var e = 0, n = new Array(t); e < t; e++) {
    n[e] = r[e];
  }

  return n;
}

var e = ["a", "com", "da", "das", "de", "do", "dos", "e", "em", "na", "nas", "no", "nos", "o", "por", "sem"],
    n = ["cnpj", "cpf", "ltda", "qp", "tv", "mei", "me", "ei", "epp", "eireli", "sa"];

module.exports = function (t) {
  var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
      a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
  if ("string" != typeof t) return t;
  var i = [].concat(r(e), r(o)),
      c = [].concat(r(n), r(a));
  return t.split(" ").filter(function (r) {
    return !!r;
  }).map(function (r, t) {
    var e = r.toLowerCase();
    return i.includes(e) && 0 !== t ? e : c.includes(e) ? e.toUpperCase() : "".concat(r.charAt(0).toUpperCase()).concat(r.substr(1).toLowerCase());
  }).join(" ");
};